import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { HiCheck } from 'react-icons/hi';
import AuthenticationService from '../service/AuthenticationService.js';
import AuthLayout from '../components/AuthLayout';
import { notifyAuthChanged } from '../util/authEvents';

// /logout: signs the user out and confirms it. The drawer's Logout button links here too.
const Logout = () => {
    const history = useHistory();

    useEffect(() => {
        AuthenticationService.logout()
        notifyAuthChanged()
    }, []);

    return (
        <AuthLayout title="You're signed out" subtitle='See you soon! Your cart and orders are saved to your account.'>
            <div className='mv-signed-out'>
                <span className='mv-signed-out-icon' aria-hidden='true'><HiCheck /></span>
                <button type='button' className='mv-btn mv-btn-primary mv-btn-block mv-auth-submit' onClick={() => history.push('/login')}>
                    Log in again
                </button>
                <button type='button' className='mv-btn mv-btn-secondary mv-btn-block' onClick={() => history.push('/')}>
                    Continue shopping
                </button>
            </div>
        </AuthLayout>
    );
};

export default Logout;
